import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

function InputText({ type, labels, onChange, value, required, style, inputStyle }) {
  const [il8n] = useTranslation();
  const [minDate, setMinDate] = useState(null);
  const [maxDate, setMaxDate] = useState(null);

  useEffect(() => {
    if (type === "date") {
      try {
        const today = new Date();
        const todayStr = today.toISOString().split("T")[0];
        setMaxDate(todayStr);  

        const storedPermission = JSON.parse(localStorage.getItem("PERMISSION") || "{}");
        const maxDateLimit = parseInt(storedPermission.MAX_DATE ?? -1);

        if (maxDateLimit >= 0) {
          const min = new Date();
          min.setDate(min.getDate() - maxDateLimit);  
          const minStr = min.toISOString().split("T")[0];
          setMinDate(minStr);
        } else {
          setMinDate(null); 
        }
      } catch (error) {
        console.error("خطأ أثناء قراءة MAX_DATE من localStorage:", error);
      }
    }
  }, [type]);


  return (
    <div
      className="input-box"
      style={inputStyle}
      dir={il8n.language === "en" ? "ltr" : "rtl"}
    >
      <input
      
        type={type}
        value={value}
        required={required}
        onChange={(e) => onChange(e.target.value)}
        placeholder={labels}
        style={style}
        {...(type === "date" && {
          min: minDate || undefined,
          max: maxDate || undefined,
        })}
      />
    </div>
  );
}

export default InputText;
